import React, {useRef, useState} from 'react';
import {Card, CardBody, CardTitle, Col, Form, FormGroup, Input, Label, Row} from 'reactstrap';
import { useForm } from "react-hook-form";
import * as Yup from "yup";

import {
    error,
    FORM,
    infoMsg,
    saveMsg,
    success,
    updateMsg
} from "../../../components/i18n/i18n";
import { showLoader } from "../../../components/loader/loader";
import {
    ButtonCancel,
    ButtonEdit,
    ButtonNew,
    ButtonSubmit,
    GenericTableButton
} from "../../../components/buttons/buttonsActions";
import {typePlaceService} from "../../../jwt/_services/hotel/typePlaceService";
import {showToastCustom} from "../../../components/toast/customToast";
import {TT_HISTORY} from "../../../components/i18n/toolTips";
import {LogHistoryModal} from "../../../components/logHistory/logHistoryModal";

const TypePlaceForm = ( props ) => {
    const [loading, setLoading] = useState(false);
    const [editMode, setEditMode] = useState(!!props?.item?.id);
    const [savedData, setSavedData] = useState(editMode ? props.item : null);

    const [, setStatus] = useState(editMode ? props.item?.status : false);
    const [, setChildChanges] = useState(false);
    const [showModal, setShowModal] = useState(true)
    const modalRef = useRef(null);

    const showHistory = () => {
        setShowModal(true);
        modalRef.current.showModal(savedData);
    }

    //Formulario
    const [disableInputs, setDisableInputs] = useState(false);
    const [saveSuccess, setSaveSuccess] = useState(false);
    const validationSchema = Yup.object().shape({});
    const {register, handleSubmit, reset} = useForm({
        validationSchema: validationSchema,
        defaultValues: {
            id        : savedData?.id,
            uid       : savedData?.uid,
            code      : savedData?.code,
        }
    });
    
    const onSubmit = (data, _) => {
        let info = {...savedData, code: data?.code}
       
        setLoading(true);

        if (!editMode) {
            return typePlaceService.saveItem(info).then(resultData => {
                setResult(resultData);
                setLoading(false);
                showToastCustom(success, saveMsg);
            }).catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
        } else {
            let id = savedData.id;
            delete savedData.id;
            
            if (JSON.stringify(savedData) === JSON.stringify(info)){
                setLoading(false);
                return showToastCustom(info, infoMsg);
            }

            info = { ...info, id }
            
            return typePlaceService.updateItem(id, info).then(resultData => {
                setResult(resultData);
                setLoading(false);
                showToastCustom(success, updateMsg);
            }).catch(errorMessage => {
                setLoading(false);
                showToastCustom(error, errorMessage);
            });
        }
    };

    const setResult = (resultData) => {
        setLoading(false);
        setSavedData(resultData);
        setDisableInputs(true);
        setSaveSuccess(true);
        setEditMode(true);
    }

    const resetForm = () => {
        setSavedData(null);
        setStatus(false);
        setEditMode(false);
        setDisableInputs(false);
        setSaveSuccess(false);
        setChildChanges(false);
        reset();
    }

    const beginEdit = () => {
        setEditMode(true);
        setSaveSuccess(false)
        setDisableInputs(false);
        setChildChanges(false);
    }

    const setForm = () => {
        props.setForm(null, null, "LIST");
    }


    return (
        <Card>
            { loading ? showLoader() : null }

            <CardTitle className="bg-light border-bottom p-3 mb-0">
                <i className="far fa-edit mr-2"/>{FORM}
                {
                    editMode && <div className="float-right">
                        <GenericTableButton
                            toolTip={TT_HISTORY}
                            icon={'fa-clock'}
                            permission={'search'}
                            onClick={showHistory}
                        />
                    </div>
                }
            </CardTitle>
            <CardBody>
                <Form onSubmit={ handleSubmit(onSubmit) }>
                    {
                        editMode &&  <Row>
                            <Col md="6">
                                <FormGroup>
                                    <Label>ID</Label>
                                    <Input 
                                        type="id" 
                                        name="id" 
                                        id="id"
                                        disabled
                                        value={ editMode ? savedData?.id : '' }
                                    />
                                </FormGroup>
                            </Col>
                            <Col md="6">
                                <FormGroup>
                                    <FormGroup>
                                        <Label>UID Firebase</Label>
                                        <Input 
                                            type="id" 
                                            name="uid" 
                                            id="uid"
                                            disabled
                                            value={ editMode ? savedData?.uid : '' }
                                        />
                                    </FormGroup>
                                </FormGroup>
                            </Col>
                        </Row>
                    }
                    <Row>
                        <Col md="6">
                            <FormGroup>
                                <Label>Código</Label>
                                <Input 
                                    type="text" 
                                    name="code"
                                    placeholder="Código"
                                    innerRef={register}
                                    disabled={disableInputs}
                                />
                            </FormGroup>
                        </Col>
                    </Row>

                    <CardBody className="border-top">
                        {
                            saveSuccess ?
                                <div className="float-right">
                                    <ButtonNew onClick={() => resetForm() }/>
                                    <ButtonEdit onClick={() => beginEdit() }/>
                                    <ButtonCancel onClick={ setForm }/>
                                </div>
                                : <div className="float-right">
                                    <ButtonSubmit/>
                                    <ButtonCancel onClick={ setForm }/>
                                </div>
                        }
                    </CardBody>
                </Form>
            </CardBody>
            {
                showModal && <LogHistoryModal
                    ref={ modalRef }
                    item={ savedData }
                />
            }
        </Card>
    )
}

export default TypePlaceForm
